module.exports = __webpack_public_path__ + "img/fall-1@3x.46089f5c.png";